import { render, staticRenderFns } from "./SmallLoader.vue?vue&type=template&id=e7cb4b5a&scoped=true&"
import script from "./SmallLoader.vue?vue&type=script&lang=ts&"
export * from "./SmallLoader.vue?vue&type=script&lang=ts&"
import style0 from "./SmallLoader.vue?vue&type=style&index=0&id=e7cb4b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7cb4b5a",
  null
  
)

export default component.exports